<template>
  <div class="h-full w-full">
    <slot></slot>
  </div>
</template>

<script setup>
// Minimal layout for embedded mode
// No navigation, no testimonials, no extra UI
// Just renders the routed component
</script>
